import API from 'libs/api';
import { createAuthInstance } from 'libs/request';
//@ts-ignore
import config from 'config/index';

class ChannelAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(`${config.api.auth}channel/`, createAuthInstance);
  }

  createChannel(payload = {}) {
    return this.instance.post('/', payload);
  }

  updateChannel(id, payload = {}) {
    return this.instance.put(`/${id}`, payload);
  }

  deleteChannel(id) {
    return this.instance.delete(`/${id}`);
  }

  getChannelById(id) {
    return this.instance.get(`/${id}`);
  }

  getChannelByRegister(params) {
    return this.instance.get(`/get-by-registeredid`, {
      params
    });
  }

  searchChannels(params = {}) {
    return this.instance.get('/', {
      params
    });
  }

  getChannelResource(channelId: string, params = {}) {
    return this.instance.get(`/${channelId}/resource`, { params });
  }

  updateChannelResource(channelId: string, resourceId: string, payload = {}) {
    return this.instance.put(`/${channelId}/resource/${resourceId}`, payload);
  }
  
  createaChannelResource(id, payload = {}) {
    return this.instance.post(`/${id}/resource`, payload)
  }

  deleteChannelResource(channelId, resId) {
    return this.instance.delete(`/${channelId}/resource/${resId}`)
  }

  searchChannelMember(id, params) {
    return this.instance.get(`${id}/member`, { params })
  }

  addMember(channelId, data) {
    return this.instance.post(`${channelId}/member`, data);
  }

  updateMember(channelId, accountId, data) {
    return this.instance.put(`${channelId}/member/${accountId}`, data);
  }

  deleteMember(channelId, accountId, data) {
    return this.instance.delete(`${channelId}/member/${accountId}`, { data })
  }

  getMember(channelId, accountId, params) {
    return this.instance.get(`${channelId}/member/${accountId}`, { params })
  }
}

export default ChannelAPI;
